<template>
  <Modal
    class="cc-modal"
    width="400"
    footer-hide
    v-model="visibility"
    :title="data.type == 0 ? '微信支付' : '支付宝支付'"
  >
    <div class="content" v-if="data">
      <div ref="qrCodeDiv" class="code-area"></div>
    </div>
    <div class="foot">
      <Button @click="onCancel">选择其他支付方式</Button>
    </div>
  </Modal>
</template>
<script>
import QRCode from "qrcodejs2";
export default {
  name: "userImageModal",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val.qrCodeUrl) this.bindQRCode(val.qrCodeUrl);
      },
    },
  },
  computed: {
    visibility: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
  methods: {
    // 二维码
    bindQRCode(val) {
      if (this.code) {
        this.$refs.qrCodeDiv.innerHTML = "";
        this.code.clear();
      }
      this.code = new QRCode(this.$refs.qrCodeDiv, {
        text: val,
        width: 160,
        height: 160,
        colorDark: "#333333", // 二维码颜色
        colorLight: "#ffffff", // 二维码背景色
        correctLevel: QRCode.CorrectLevel.L, // 容错率，L/M/H
      });
    },
    onCancel() {
      this.visibility = false;
    },
  },
};
</script>
<style lang="less" scoped>
.cc-modal {
  .content {
    height: auto;
    min-height: 100px;
    max-height: 500px;
    overflow: auto;
  }
  .foot {
    border-top: 1px solid #dcdee2;
    padding-top: 16px;
    display: flex;
    justify-content: flex-end;
  }
}
.row {
  display: flex;
  line-height: 40px;
  .name {
    min-width: 120px;
    text-align: right;
    margin-right: 20px;
  }
}
.code-area {
  width: 160px;
  height: 160px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50%;
  background-color: #f7f7f7;
  margin: 0 auto 20px;
}
</style>
